import { playerStoreKeys } from '../playerStoreConstants'
import { useSetPlayerStoreData } from '../hooks'
import { useCallback } from 'react'
import { usePlayerStore } from '../hooks/usePlayerStore'

export const useTogglePlayerFavoriteGame = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()
  const playerStore = usePlayerStore()
  const favoriteGames = playerStore.use.favoriteGames()

  const togglePlayerFavoriteGame = useCallback(
    gameId => {
      const newFavoriteGames = { ...favoriteGames, [gameId]: !favoriteGames[gameId] }

      setPlayerStoreData(
        {
          [playerStoreKeys.favoriteGames]: newFavoriteGames
        },
        'togglePlayerFavoriteGame'
      )
    },
    [favoriteGames, setPlayerStoreData]
  )

  return { togglePlayerFavoriteGame }
}
